import { render, staticRenderFns } from "./stock-taking.vue?vue&type=template&id=4cac169c&scoped=true&"
import script from "./stock-taking.vue?vue&type=script&lang=js&"
export * from "./stock-taking.vue?vue&type=script&lang=js&"
import style0 from "./stock-taking.vue?vue&type=style&index=0&id=4cac169c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cac169c",
  null
  
)

export default component.exports